<template>
  <component v-if="setbrandid && TermsComponent" :is="TermsComponent"/>
  <!-- <YourDetailsDefault v-else-if="setbrandid" /> -->
</template>

<script>
import { markRaw } from "vue";
import apiProxy from "../../services/apiProxy";

// import YourDetailsDefault from "./YourDetailsDefault.vue";

export default {
  name: "App",
  components: {
    //YourDetailsDefault,
  },
  data() {
    return {
      setbrandid: "",
      TermsComponent: null,
      use_newflow: false,
    };
  },
  methods: {
    async getbranded() {
      const response = await apiProxy.call('brand_slug');
      if (response && response.code == "1") {
        this.setbrandid = response.slug;
        await this.getComponent();
      }
    },
    async getComponent() {
      let module;
      let brand = this.setbrandid;
      if (brand === "BH1" || brand === "BH2") {
        brand = "BHX";
      }
      if (brand === "SB3" || brand === "SB4" || brand === "SB5") {
        brand = "SB2";
      }
      //alert("testing " + brand);
      module = await import(`../Terms/Terms${brand}.vue`);
      this.TermsComponent = markRaw(module.default);
    },
  },
  beforeMount() {
    this.getbranded();
  },
  mounted() {
    // Remove the loader once Vue is initialized
    const loader = document.getElementById("loader");
    if (loader) {
      loader.parentNode.removeChild(loader);
    }
  },
};
</script>
